/**
 * LP 검사 결과 Blur 해제 대상 설정
 *
 * 지정된 센터의 지정된 아동에 대해 검사 결과 화면의 blur 처리를 해제합니다.
 * - centerId: 센터 ID (필수)
 * - childIds: 해당 센터에서 blur 해제할 아동 ID 배열 (빈 배열이면 해당 센터의 모든 아동 blur 해제)
 */
export interface InspectionBlurWhitelistItem {
    /** 센터 ID */
    centerId: string;
    /** Blur 해제할 아동 ID 배열 (빈 배열이면 해당 센터의 모든 아동에 대해 blur 해제) */
    childIds: string[];
}

/**
 * LP 검사 결과 Blur 해제 대상 목록
 *
 * @example
 * // 특정 센터의 특정 아동만 blur 해제
 * { centerId: 'center_abc123', childIds: ['child_123', 'child_456'] }
 *
 * @example
 * // 특정 센터의 모든 아동 blur 해제
 * { centerId: 'center_xyz789', childIds: [] }
 */
export const INSPECTION_BLUR_WHITELIST: InspectionBlurWhitelistItem[] = [
    // 아래에 blur 해제할 센터/아동 정보를 추가하세요
    // { centerId: 'center_id_here', childIds: ['child_id_1', 'child_id_2'] },
    // { centerId: 'another_center_id', childIds: [] }, // 빈 배열 = 해당 센터의 모든 아동
    {
        centerId: "C260119771121",
        childIds: ["UMIE990", "JAWD492", "UKCB509", "XLPZ674"],
    },
];

/**
 * 특정 센터/아동이 blur 해제 대상인지 확인합니다.
 * @param centerId 센터 ID
 * @param childId 아동 ID
 * @returns blur 해제 대상이면 true
 */
export function isBlurWhitelisted(childId: string | null | undefined): boolean {
    if (!childId) return false;

    const whitelistItem = INSPECTION_BLUR_WHITELIST.find((item) =>
        item.childIds.includes(childId),
    );

    return !!whitelistItem;
}
